/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation, useQuery } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import axiosInstance from '../functions/AxiosInstance'; // Asegúrate de que la ruta sea correcta


const addToWishlist = async ({ templateId, digitalAssetId }: { templateId?: string; digitalAssetId?: string }) => {
  if (!templateId && !digitalAssetId) {
    throw new Error("Debe proporcionar un Template ID o un Digital Asset ID.");
  }

  const response = await axiosInstance.post("/wish-lists/", { templateId, digitalAssetId });
  return response.data;
};

export const useAddToWishlist = () => {
  const mutation = useMutation({
    mutationFn: addToWishlist,
    onSuccess: (data) => {
      toast.success(data?.message || "Elemento agregado al wishlist con éxito.");
    },
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Error desconocido";

      toast.error(errorMessage);
      console.error("Error al agregar al wishlist:", errorMessage);
    },
  });

  return {
    ...mutation,
    isLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
  };
};


// Función para obtener el wishlist de un usuario
const fetchWishlistByUser = async () => {
  try {
    const response = await axiosInstance.get('/wish-lists');
    return response.data; // Devuelve los datos de la respuesta
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || 'Error desconocido';
    toast.error(`Error al obtener el wishlist: ${errorMessage}`);
    console.error('Error al obtener el wishlist:', errorMessage);
    throw new Error(errorMessage); // Lanza el error para manejarlo en el hook
  }
};

// Hook para obtener el wishlist de un usuario
export const useGetWishlistByUser = () => {
  const { data, error, isLoading, isError, isSuccess, refetch } = useQuery({
    queryKey: ['wishlist'], // Identificador de la consulta en React Query
    queryFn: fetchWishlistByUser, // Función para obtener el wishlist
    refetchOnWindowFocus: false, // Opcional: Evita que los datos se vuelvan a obtener cuando el foco de la ventana cambia
  });

  return {
    wishlist: data,         // El wishlist del usuario
    isLoading,              // Si está cargando
    isError,                // Si hubo un error
    error,                  // El error completo (si existe)
    isSuccess,              // Si la consulta fue exitosa
    refetch,                // Función para volver a hacer la consulta
  };
};




// Función para eliminar un template o un digital asset del wishlist
const removeFromWishlist = async ({ templateId, digitalAssetId }: { templateId?: string; digitalAssetId?: string }) => {
  try {
    if (!templateId && !digitalAssetId) {
      throw new Error('Debe proporcionar un Template ID o un Digital Asset ID.');
    }

    const response = await axiosInstance.delete(`/wish-lists/`, {
      data: { templateId, digitalAssetId }, // Enviar los datos en el cuerpo de la petición DELETE
    });

    return response.data;
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || 'Error desconocido';
    toast.error(`Error al eliminar del wishlist: ${errorMessage}`);
    console.error('Error al eliminar del wishlist:', errorMessage);
    throw new Error(errorMessage);
  }
};

// Hook para eliminar un elemento del wishlist
export const useRemoveFromWishlist = () => {
  const mutation = useMutation({
    mutationFn: removeFromWishlist,
    onSuccess: () => {
      toast.success('Elemento eliminado del wishlist con éxito.');
    },
    onError: (error: any) => {
      const errorMessage = error?.message || 'Error desconocido';
      console.error('Error al eliminar del wishlist:', errorMessage);
      toast.error(errorMessage);
    },
  });

  return {
    ...mutation,
    isLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
    error: mutation.error?.message || '',
  };
};
